import {useEffect, useState} from 'react'
import {useNavigate, useLocation} from 'react-router-dom'

export function MobileBackButton() {
  const navigate = useNavigate()
  const location = useLocation()
  const [canGoBack, setCanGoBack] = useState(false)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    // Check if we can go back (not on dashboard and has history)
    const isDashboard = location.pathname === '/dashboard' || location.pathname === '/'
    setCanGoBack(!isDashboard && window.history.length > 1)
  }, [location])

  useEffect(() => {
    // Show button after 3 seconds
    const timer = setTimeout(() => {
      setIsVisible(true)
    }, 3000)

    return () => clearTimeout(timer)
  }, [location])

  const handleBack = () => {
    navigate(-1)
  }

  if (!canGoBack || !isVisible) {
    return null
  }

  return (
    <div
      className='d-lg-none'
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '20px',
        zIndex: 1000,
        animation: 'slideInLeft 0.3s ease-out'
      }}
    >
      <button
        onClick={handleBack}
        className='btn btn-icon'
        style={{
          width: '56px',
          height: '56px',
          borderRadius: '50%',
          background: 'rgba(80, 130, 245, 0.06)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08), inset 0 1px 1px rgba(255, 255, 255, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.06)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.3s ease',
          cursor: 'pointer'
        }}
        onMouseDown={(e) => {
          e.currentTarget.style.transform = 'scale(0.95)'
        }}
        onMouseUp={(e) => {
          e.currentTarget.style.transform = 'scale(1)'
        }}
        onTouchStart={(e) => {
          e.currentTarget.style.transform = 'scale(0.95)'
        }}
        onTouchEnd={(e) => {
          e.currentTarget.style.transform = 'scale(1)'
        }}
        title='Go back'
      >
        <i className='bi bi-arrow-left fs-2' style={{ color: '#fff', textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)' }}></i>
      </button>
      <style>{`
        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
      `}</style>
    </div>
  )
}
